import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { gql } from "types";

export const CONTINUE_WORKFLOW_RUN = gql(/* GraphQL */ `
  mutation ContinueWorkflowRun($runId: String!) {
    continueWorkflowRun(runId: $runId) {
      id
      status
    }
  }
`);

export const EXIT_WORKFLOW_RUN = gql(/* GraphQL */ `
  mutation ExitWorkflowRun($runId: String!) {
    exitWorkflowRun(runId: $runId) {
      id
      status
    }
  }
`);

/**
 * Fires the support-tool mutations for a workflow run stranded in `Created`:
 * `continue` re-signals Temporal to execute it, `exit` closes it without
 * running any node. Side effects (toasts, refetch) are left to the caller.
 */
export const useWorkflowRunLifecycle = () => {
  const [continueWorkflowRun, { loading: continuing }] = useMutation(
    CONTINUE_WORKFLOW_RUN,
  );
  const [exitWorkflowRun, { loading: exiting }] =
    useMutation(EXIT_WORKFLOW_RUN);

  const continueRun = useCallback(
    (runId: string) => continueWorkflowRun({ variables: { runId } }),
    [continueWorkflowRun],
  );

  const exitRun = useCallback(
    (runId: string) => exitWorkflowRun({ variables: { runId } }),
    [exitWorkflowRun],
  );

  return { continueRun, exitRun, continuing, exiting };
};
